// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__2k8wD"};